var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseFilters", {
    attrs: {
      bem: _vm.bemBlock,
      "filter-display-name": _vm.filterDisplayName,
      "is-select-multiple": false,
      show: _vm.range && _vm.range.length == 2
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c("VueSlider", {
              class: _vm.bemElement("control"),
              attrs: {
                "drag-on-click": true,
                disabled: _vm.loading,
                contained: true,
                "dot-size": 11,
                "enable-cross": false,
                height: 3,
                min: _vm.rangeMin,
                max: _vm.rangeMax,
                tooltip: "none"
              },
              on: { "drag-end": _vm.emitNewFilteredRange },
              model: {
                value: _vm.value,
                callback: function($$v) {
                  _vm.value = $$v
                },
                expression: "value"
              }
            }),
            _vm._v(" "),
            _c("p", { class: _vm.bemElement("info") }, [
              _c("span", { class: _vm.bemElement("from") }, [
                _vm._v(_vm._s(_vm.formattedValueFrom))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "visually-hidden" }, [_vm._v("-")]),
              _vm._v(" "),
              _c("span", { class: _vm.bemElement("to") }, [
                _vm._v(_vm._s(_vm.formattedValueTo))
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }